import * as types from './mutation-types'

export default {
  // 新增运动两平衡食物选择列表
  [types.SAVE_PHFOOD] (state, plan) {
    state.phfoodlist.push(plan)
  },
  // 删除运动两平衡食物选择列表
  [types.DELETE_PHFOOD] (state, idx) {
    state.phfoodlist.splice(idx, 1);
  },
  // 新增重量
  [types.PH_ADD_WEIGHT] (state, objadd) {
    state.phfoodlist[objadd.obj_index].foodWeight += objadd.obj_weight;
  },
  // 新增血糖指数食物选择列表
  [types.SAVE_GIS_FOOD] (state, plan) {
    state.gisfoodlist.push(plan)
  },
  // 删除血糖指数食物选择列表
  [types.DELETE_GIS_FOOD] (state, idx) {
    state.gisfoodlist.splice(idx, 1);
  },
  // 新增重量
  [types.GIS_ADD_WEIGHT] (state, objadd) {
    state.gisfoodlist[objadd.obj_index].foodWeight += objadd.obj_weight;
  },
  // 新增餐前注射胰岛素食物选择列表
  [types.SAVE_CARBO_FOOD_BEFORE] (state, plan) {
    state.carbofoodlist1.push(plan)
  },
  // 删除餐前注射胰岛素食物选择列表
  [types.DELETE_CARBO_FOOD_BEFORE] (state, idx) {
    state.carbofoodlist1.splice(idx, 1);
  },
  // 新增重量
  [types.CARBOBEFORE_ADD_WEIGHT] (state, objadd) {
    state.carbofoodlist1[objadd.obj_index].foodWeight += objadd.obj_weight;
  },
  // 新增补打胰岛素食物选择列表
  [types.SAVE_CARBO_FOOD_AFTER] (state, plan) {
    state.carbofoodlist2.push(plan)
  },
  // 删除补打胰岛素食物选择列表
  [types.DELETE_CARBO_FOOD_AFTER] (state, idx) {
    state.carbofoodlist2.splice(idx, 1);
  },
  // 新增重量
  [types.CARBOAFTER_ADD_WEIGHT] (state, objadd) {
    state.carbofoodlist2[objadd.obj_index].foodWeight += objadd.obj_weight;
  }
};


// WEBPACK FOOTER //
// ./src/store/mutations.js